// src/components/PageLoader.jsx
import React from 'react';
import { motion } from 'framer-motion';
import '../styles/main.css';

const PageLoader = () => {
  return (
    <motion.div 
      className="page-loader"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <div className="loader-content">
        <motion.div 
          className="loader-logo"
          animate={{ 
            rotate: 360,
            scale: [1, 1.1, 1]
          }}
          transition={{
            rotate: {
              duration: 2,
              ease: "linear",
              repeat: Infinity
            },
            scale: {
              duration: 1,
              ease: "easeInOut",
              repeat: Infinity,
              repeatType: "reverse"
            }
          }}
        >
          🚖
        </motion.div>
        <motion.h3
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
        >
          Mahalakshmi Cabs
        </motion.h3>
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4 }}
        >
          Loading your journey...
        </motion.p>
      </div>
    </motion.div>
  );
};

export default PageLoader;